import dayjs from 'dayjs';

// Dates are shown in Indian time — the newsroom's — whatever the computer's clock says.

const dateTime = new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
const dateOnly = new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short', year: 'numeric' });
const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export const formatDateTime = (iso: string | null | undefined) => (iso ? dateTime.format(new Date(iso)) : '—');
export const formatDate = (iso: string | null | undefined) => (iso ? dateOnly.format(new Date(iso)) : '—');

export function timeAgo(iso: string | null | undefined) {
  if (!iso) return '—';
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  const steps: [Intl.RelativeTimeFormatUnit, number][] = [
    ['second', 60],
    ['minute', 60],
    ['hour', 24],
    ['day', 30],
    ['month', 12],
    ['year', Infinity],
  ];
  let value = seconds;
  for (const [unit, size] of steps) {
    if (Math.abs(value) < size) return relative.format(Math.round(value), unit);
    value /= size;
  }
  return formatDate(iso);
}

export const formatNumber = (n: number | null | undefined) => (n === null || n === undefined ? '—' : n.toLocaleString('en-IN'));
export const formatPercent = (ratio: number) => `${(ratio * 100).toFixed(2)}%`;

export function formatBytes(bytes: number | null | undefined) {
  if (!bytes) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toFixed(value < 10 && unit > 0 ? 1 : 0)} ${units[unit]}`;
}

export const formatDuration = (sec: number | null | undefined) => (sec === null || sec === undefined ? '—' : `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`);

/** A date picker's local value ("2026-09-14 18:30:00" or a Date) → the ISO time the API takes. */
export function toIso(value: string | Date | null | undefined) {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toISOString() : null;
}

/** ISO → the date picker's local value. */
export const fromIso = (iso: string | null | undefined) => (iso ? dayjs(iso).format('YYYY-MM-DD HH:mm:ss') : null);

/** Today in India, as YYYY-MM-DD. */
export function istToday(offsetDays = 0) {
  const now = new Date(Date.now() + offsetDays * 86_400_000);
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(now);
}

/** A readable name for a status or key: "in_review" → "In review". */
export const humanize = (value: string) => (value.charAt(0).toUpperCase() + value.slice(1)).replace(/_/g, ' ');
